import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import type { AvtaleStatus } from "@/api/generated";
import { formatDateStringInterval } from "@/utils";
import { BekreftelseToForside } from "./BekreftelseToForside";

export const BekreftelseAvtaleIkkeAktiv = ({
  avtaleStatus,
  periodeFra,
  periodeTil,
}: {
  avtaleStatus: AvtaleStatus | undefined;
  periodeFra: string | undefined;
  periodeTil: string | undefined;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col my-8">
      <Alert>
        <Heading level={2} data-size="sm">
          {t("pages.avtaler.statuser.avtaleStatus", {
            context: avtaleStatus,
          })}
        </Heading>
        <Paragraph className="whitespace-pre-line">
          {t("pages.bekreftelse.ikke-aktiv", {
            periode: formatDateStringInterval(periodeFra, periodeTil),
          })}
        </Paragraph>
      </Alert>
      <div className="mt-8">
        <BekreftelseToForside />
      </div>
    </div>
  );
};
